var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lamp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.22 166.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ae100f58-6ced-4268-a957-12c07bbbf9a9{fill:#fff;fill-opacity:0.2;}.f41bb4b5-80d0-4acf-9729-b902b57fc813{fill:none;stroke:#77a1a6;stroke-width:3.32px;}.a86ff782-8d00-47d6-ac62-2e1c9db54235,.b1388ec8-8eb7-4a54-a327-dc7290c54702{fill:#77a1a6;}.b1388ec8-8eb7-4a54-a327-dc7290c54702{fill-rule:evenodd;}.b2d0bc72-96a9-4423-935a-7fe11e079f09{fill:#f2f2f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc2e1815-9cf7-447d-a9be-71f08b628204",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e78aeaf8-c3ad-4be7-a9d3-c6bdd1d7e54f",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae100f58-6ced-4268-a957-12c07bbbf9a9",
    d: "M251.48,134.87,304,32.74,289.43,12.87,0,132.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f41bb4b5-80d0-4acf-9729-b902b57fc813",
    d: "M309.27,10.36,317,2.64a3.32,3.32,0,0,1,4.7,0h0l20.54,20.55a6.64,6.64,0,0,1,1.94,4.7V164"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a86ff782-8d00-47d6-ac62-2e1c9db54235",
    d: "M355,163.58H333a1.25,1.25,0,0,0-1.24,1.25v.41a1.25,1.25,0,0,0,1.24,1.25h22a1.25,1.25,0,0,0,1.24-1.25v-.41A1.25,1.25,0,0,0,355,163.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1388ec8-8eb7-4a54-a327-dc7290c54702",
    d: "M313.91,5.83a13.72,13.72,0,0,1,0,19.39l-8.23,8.22L286.29,14.05l8.23-8.22A13.7,13.7,0,0,1,313.91,5.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b2d0bc72-96a9-4423-935a-7fe11e079f09",
    d: "M294.41,25.44c5.35,5.35,10.55,8.84,11.6,7.78s-2.43-6.25-7.78-11.6-10.56-8.84-11.61-7.79S289.05,20.08,294.41,25.44Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.4f19b8c2.svg";
export { ForwardRef as ReactComponent };